import { useState, useEffect } from 'react'

export const useTrafficSource = () => {
  const [trafficSource, setTrafficSource] = useState('')

  useEffect(() => {
    const getCookieValue = (name: string): string | undefined => {
      const match = document.cookie.match(
        '(^|;)\\s*' + name + '\\s*=\\s*([^;]+)'
      )
      return match ? decodeURIComponent(match[2]) : undefined
    }

    const source = getCookieValue('__trf.src') || getCookieValue('__utmzz')

    if (!source && process.env.NODE_ENV === 'development') {
      setTrafficSource('direct')
      return
    }

    setTrafficSource(source || '')
  }, [])

  return trafficSource
}
